import { BaseGetProvider } from "@tendercuts/http";
import { EndPoint } from "@endpoint";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoginServices } from "@login";
import { OutofStockProducts } from '../../models';

/**
 * used to fetch the out of products
 */
@Injectable({ providedIn: "root" })
export class OutOfStockProductsService extends BaseGetProvider<
  OutofStockProducts
> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint
  ) {
    super(http);
  }

  get isCachable() {
    return false;
  }

  get isAuthenticatedEndpoint() {
    return true;
  }

  get authProtocol() {
    return this.loginService;
  }

  get model() {
    return OutofStockProducts;
  }

  get endpoint() {
    return this.endpointService.outOfStockProduct();
  }

  getParams(storeId) {
    const params = {
      store_id: storeId
    };
    return params;
  }
}
